export const PROJECT_SCHEMA_VERSION = 1;
export const PROJECT_KIND = 'omniapps.archer.project';
export const ARCHER_APP_NAME = 'archer';
export const DEFAULT_BRAND_COLOR = '#3D9168';
export const DEFAULT_BRAND_RGB = [61, 145, 104];
export const DEFAULT_SHAPE_FILL = '#ffffff';
export const DEFAULT_SHAPE_STROKE = '#1f2937';
export const DEFAULT_SHAPE_STROKE_WIDTH = 1.5;
export const DEFAULT_TEXT_FILL = '#111827';
export const DEFAULT_FONT_SIZE = 14;
export const DEFAULT_FONT_FAMILY = 'Inter, system-ui, sans-serif';
export const DEFAULT_GRID_SIZE = 20;
export const DEFAULT_SNAP_TOLERANCE = 6;
export const MERMAID_DIAGRAM_TYPES = [
    'flowchart',
    'sequence',
    'class',
    'state',
    'er',
    'gantt',
    'c4Context',
    'c4Container',
    'c4Component',
    'c4Dynamic',
    'c4Deployment',
    'journey',
    'requirement',
    'gitgraph',
    'mindmap',
    'timeline',
    'block',
    'pie',
    'quadrant',
    'sankey',
    'packet',
    'architecture',
    'radar',
];
//# sourceMappingURL=constants.js.map